import * as React from 'react';

/**
 * Returns a keydown handler that blurs the target element when Enter is
 * pressed, committing the current inline-edit value. Shared by PriceInput and
 * NoteInput so both inputs use an identical Enter-commit contract.
 */
export function onKeyDownCommitOnEnter(e: React.KeyboardEvent<HTMLElement>): void {
  if (e.key === 'Enter') {
    e.preventDefault();
    e.currentTarget.blur();
  }
}
